export default "__VITE_ASSET__CpK1Q7yz__"